
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { Progress } from "@/components/ui/progress";
import { useOnboarding } from "./OnboardingProvider";
import { ProfileStep } from "./steps/ProfileStep";
import { CashbackStep } from "./steps/CashbackStep";
import { TermsStep } from "./steps/TermsStep";
import { WelcomeStep } from "./steps/WelcomeStep";

export function OnboardingModal() {
  const { currentStep, steps, isOnboardingOpen, nextStep, prevStep, closeOnboarding } = useOnboarding();

  const progress = ((currentStep + 1) / steps.length) * 100;

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <ProfileStep onNext={nextStep} />;
      case 1:
        return <CashbackStep onNext={nextStep} onPrev={prevStep} />;
      case 2:
        return <TermsStep onNext={nextStep} onPrev={prevStep} />;
      case 3:
        return <WelcomeStep onPrev={prevStep} />;
      default:
        return <ProfileStep onNext={nextStep} />;
    }
  };

  return (
    <Dialog open={isOnboardingOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-[500px] max-h-[80vh] overflow-y-auto">
        <DialogHeader className="space-y-4">
          <div className="space-y-2">
            <div className="flex justify-between text-sm text-muted-foreground">
              <span>Passo {currentStep + 1} de {steps.length}</span>
              <span>{Math.round(progress)}% completo</span>
            </div>
            <Progress value={progress} className="h-2" />
          </div>
          
          <div className="flex gap-2">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className={`flex-1 h-2 rounded-full ${
                  index <= currentStep 
                    ? 'bg-primary' 
                    : 'bg-muted'
                }`}
              />
            ))}
          </div>
        </DialogHeader>

        <div className="py-4">
          {renderStep()}
        </div>
      </DialogContent>
    </Dialog>
  );
}
